import { useCallback, useState } from 'react';

export const useBooleanControl = ({ value: valueProp = false } = { value: false }) => {
  const [value, setValue] = useState(valueProp);

  const onDisable = useCallback(() => {
    setValue(false);
  }, []);
  const onEnable = useCallback(() => {
    setValue(true);
  }, []);
  const onToggle = useCallback(() => {
    setValue((value) => {
      return !value;
    });
  }, []);

  return { onDisable, onEnable, onToggle, value };
};
